// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._2gzxk90 {
  padding: var(--_18w76bwg) var(--_18w76bwj);
}
._2gzxk91 {
  padding-bottom: 60px;
  border-bottom: 1px solid var(--_18w76bw28);
}
@media screen and (max-width: 767px) {
  ._2gzxk90 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: var(--_18w76bwh) var(--_18w76bwg);
  }
  ._2gzxk91 {
    border: none;
    padding-bottom: var(--_18w76bwh);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,0CAA0C;AAC5C;AACA;EACE,oBAAoB;EACpB,0CAA0C;AAC5C;AACA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,0CAA0C;EAC5C;EACA;IACE,YAAY;IACZ,gCAAgC;EAClC;AACF","sourcesContent":["._2gzxk90 {\n  padding: var(--_18w76bwg) var(--_18w76bwj);\n}\n._2gzxk91 {\n  padding-bottom: 60px;\n  border-bottom: 1px solid var(--_18w76bw28);\n}\n@media screen and (max-width: 767px) {\n  ._2gzxk90 {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n    padding: var(--_18w76bwh) var(--_18w76bwg);\n  }\n  ._2gzxk91 {\n    border: none;\n    padding-bottom: var(--_18w76bwh);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
